import { useMemo } from 'react';
import {
  textHasHighlightMatches,
  textHasHighlightMatchesAfterOffset,
} from './highlight-utils';
import type { HighlightPattern } from './types';

export type HighlightMatchSummary = {
  inPost: boolean;
  inHiddenPost: boolean;
};

const EMPTY: HighlightMatchSummary = {
  inPost: false,
  inHiddenPost: false,
};

export const useHighlightMatchSummary = ({
  postText,
  patterns,
  maxChars,
}: {
  postText: string | null | undefined;
  patterns: HighlightPattern[] | undefined;
  maxChars: number | null | undefined;
}): HighlightMatchSummary =>
  useMemo(() => {
    if (!patterns?.length) return EMPTY;
    const budgetText = (postText || '').replaceAll('\n', '');
    const inPost = textHasHighlightMatches(budgetText, patterns);
    const inHiddenPost =
      inPost && maxChars
        ? textHasHighlightMatchesAfterOffset(budgetText, patterns, maxChars)
        : false;
    return { inPost, inHiddenPost };
  }, [postText, patterns, maxChars]);
